class CustomSearchProducts extends HTMLElement {
  constructor() {
    super();
    this.searchHistory = this.querySelector('[data-search-history]');
    this.productsContainer = this.querySelector('[data-products]');
    this.storageKey = this.getAttribute('data-storage-key');
    this.maxItems = 6; // Show maximum 6 recent products


    this.input = document.querySelector('[data-input-search-in-modal]');

    this.loadRecentProducts();
  }

  async loadRecentProducts() {
    try {
      this.toggleHistory();
      const productHandles = this.getStoredProductHandles();
      if (productHandles.length === 0) {
        return;
      }

      const products = await this.fetchProductsByHandles(productHandles.slice(0, this.maxItems));
      this.renderProducts(products);
    } catch (error) {
      console.error('Failed to load recent products:', error);
    }
  }

  getStoredProductHandles() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Failed to parse stored product handles:', error);
      return [];
    }
  }

  async fetchProductsByHandles(productHandles) {
    const fetchPromises = productHandles.map(async (productHandle) => {
      try {
        // Use the product.js endpoint to fetch product data by handle
        const productUrl = `${window.location.origin}/products/${productHandle}.js`;
        const response = await fetch(productUrl);

        if (!response.ok) {
          throw new Error(`Failed to fetch product ${productHandle}: ${response.status}`);
        }

        const productData = await response.json();
        return productData;
      } catch (error) {
        console.error(`Failed to fetch product ${productHandle}:`, error);
        return null;
      }
    });

    const products = await Promise.all(fetchPromises);
    return products.filter(product => product !== null);
  }

  formatPrice(priceInCents) {
    // Convert price from cents to currency format
    const price = priceInCents / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(price);
  }

  renderProducts(products) {
    if (!this.productsContainer || products.length === 0) {
      this.hide();
      return;
    }

    // Render products using the JSON data
    const productsHTML = products.map(product => {
      return this.renderProductItem(product);
    }).join('');

    this.productsContainer.innerHTML = productsHTML;
  }

  renderProductItem(product) {
    const firstVariant = product.variants && product.variants[0];
    const price = firstVariant ? this.formatPrice(firstVariant.price) : '';
    const compareAtPrice = firstVariant && firstVariant.compare_at_price ? this.formatPrice(firstVariant.compare_at_price) : '';
    const productUrl = `/products/${product.handle}`;

    const priceHTML = compareAtPrice && compareAtPrice !== price
      ? `<div class="search-card__price">
          <span class="search-card__price--compare">${compareAtPrice}</span>
          <span class="search-card__price--sale">${price}</span>
         </div>`
      : `<div class="search-card__price">${price}</div>`;

    return `
      <a href="${productUrl}" class="search-card">
         <div class="search-card__media">
            ${product.featured_image ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy">` : ''}
          </div>
          <div class="search-card__details">
            <h4 class="search-card__title">${product.title || 'Unknown Product'}</h4>
            ${priceHTML}
          </div>
      </a>
    `;
  }

  toggleHistory() {
    const productHandles = this.getStoredProductHandles();
    const inputEmpty = !this.input || this.input.value.trim() === '';
    if (!this.searchHistory) {
      return;
    }
    const shouldShowHistory = productHandles.length > 0 && inputEmpty;

    this.searchHistory.style.display = shouldShowHistory ? 'block' : 'none';
  }

  customSearchProductsHide() {
    this.toggleHistory();
    this.removeAttribute('data-show');
  }

  customSearchProductsShow() {
    this.toggleHistory();
    this.setAttribute('data-show', '');
  }

  // Method to refresh the search history when new products are added
  refresh() {
    this.loadRecentProducts();
  }
}

// Define the custom element
customElements.define('custom-search-products', CustomSearchProducts);
